(function () {
  const config = window.diggnEidGiftConfig || {};

  if (!config.enabled || !config.giftVariantId) return;

  const SOURCE = 'eid-gift-with-purchase';
  const giftVariantId = Number(config.giftVariantId);
  const giftProperties = config.giftProperties || {};
  let syncInProgress = false;
  let pendingSync = false;
  let activeSyncPromise = null;
  let releasingCheckout = false;

  function isManagedGiftLine(item) {
    if (Number(item.variant_id) !== giftVariantId) return false;

    const properties = item.properties || {};
    return properties._diggn_gift_offer === config.offerKey;
  }

  function isGiftVariant(item) {
    return Number(item.variant_id) === giftVariantId;
  }

  function hasQualifyingItem(cart) {
    return cart.items.some((item) => !isGiftVariant(item) && item.quantity > 0);
  }

  function hasExpectedGiftProperties(item) {
    const properties = item.properties || {};
    return properties['Best Before'] === '07/2026' && !properties['Best used before'];
  }

  async function fetchCart() {
    const response = await fetch(`${routes.cart_url}.js`, {
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) throw new Error('Unable to read cart.');

    return response.json();
  }

  async function addManagedGift() {
    const body = {
      items: [
        {
          id: giftVariantId,
          quantity: 1,
          properties: giftProperties,
        },
      ],
    };

    const response = await fetch(routes.cart_add_url, {
      ...fetchConfig(),
      body: JSON.stringify(body),
    });

    if (!response.ok) throw new Error('Unable to add complimentary gift.');

    return response.json();
  }

  async function changeManagedGift(line, quantity, properties = null) {
    const body = {
      line,
      quantity,
    };

    if (properties) {
      body.properties = properties;
    }

    const response = await fetch(routes.cart_change_url, {
      ...fetchConfig(),
      body: JSON.stringify(body),
    });

    if (!response.ok) throw new Error('Unable to update complimentary gift.');

    return response.json();
  }

  function notifyCartUpdated(cartData) {
    if (typeof publish !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: SOURCE,
      cartData,
      variantId: giftVariantId,
    });
  }

  async function syncGift() {
    if (syncInProgress) {
      pendingSync = true;
      return activeSyncPromise;
    }

    syncInProgress = true;
    pendingSync = false;

    activeSyncPromise = (async () => {
      const cart = await fetchCart();
      const qualifies = hasQualifyingItem(cart);
      const managedGiftLineIndex = cart.items.findIndex(isManagedGiftLine);
      const managedGift = managedGiftLineIndex >= 0 ? cart.items[managedGiftLineIndex] : null;

      if (!qualifies && managedGift) {
        const updatedCart = await changeManagedGift(managedGiftLineIndex + 1, 0);
        notifyCartUpdated(updatedCart);
        return;
      }

      if (qualifies && !cart.items.some(isGiftVariant)) {
        const addedItem = await addManagedGift();
        notifyCartUpdated(addedItem);
        return;
      }

      if (qualifies && managedGift && managedGift.quantity !== 1) {
        const updatedCart = await changeManagedGift(managedGiftLineIndex + 1, 1);
        notifyCartUpdated(updatedCart);
        return;
      }

      if (qualifies && managedGift && !hasExpectedGiftProperties(managedGift)) {
        const updatedCart = await changeManagedGift(managedGiftLineIndex + 1, 1, giftProperties);
        notifyCartUpdated(updatedCart);
      }
    })();

    try {
      await activeSyncPromise;
    } catch (error) {
      console.warn('Diggn gift sync skipped:', error);
    } finally {
      syncInProgress = false;
      activeSyncPromise = null;

      if (pendingSync) {
        window.setTimeout(syncGift, 250);
      }
    }
  }

  function scheduleSync() {
    window.setTimeout(syncGift, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSync);
  } else {
    scheduleSync();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event && event.source === SOURCE) return;
      scheduleSync();
    });
  }

  document.addEventListener(
    'click',
    async (event) => {
      const checkoutButton = event.target.closest('button[name="checkout"], input[name="checkout"]');

      if (!checkoutButton || releasingCheckout || checkoutButton.disabled) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      await syncGift();

      releasingCheckout = true;
      checkoutButton.click();
      releasingCheckout = false;
    },
    true
  );
})();
